const ErrorPage = () => {
    return (
        <>Error Page</>
    )
}

export default ErrorPage;